import * as React from "react";
import BasePopup from "../../../popups/BasePopup.jsx"
import { styled } from "@mui/material/styles";

const StyledDataList = styled('dl')({
  borderCollapse: "collapse",
  width: "100%",
  "& > :nth-of-type(odd)": {
    backgroundColor: "rgba(150, 150, 150, 0.2)",
  },
  "& div": {
    display: "flex",
    marginRight: "1rem",
  },
  "& div dt": {
    flexShrink: 0,
    fontWeight: "bold",
    width: "120px",
    paddingLeft: "5px",
  },
  "& div dd": {
    flexGrow: 1,
    marginLeft: 0,
    paddingLeft: "10px",
    paddingRight: "5px",
  },
})

const spendIndexIntro = (props) => {
  return (
    <>
    <p>
      Index value is relative in-store retail credit and debit card spend to London wide average.
    </p>
    {props.txn_amt == 0 && (
      <div>
        <p style={{
          marginBottom: 4,
        }}>
        <b>Note:</b> This grid has a typical spend index value of 0. This could be due to:</p>
        <ul style={{
          marginTop: 4,
          paddingLeft: 16,
        }}>
          <li><b>Genuinely no retail activity on the ground.</b></li>
          <li><b>Suppression for retailer confidentiality:</b> Spend index is only reported if a grid covers 5 or more merchants in one group and no merchant makes up more than 25% of the total.</li>
          <li><b>Retailer address:</b> The retailer's registered address may be different from the location of the sale. This is common with market stalls.</li>
        </ul>
      </div>
    )}
    </>
  )
}

const renderDataList = (title, intro, rows, first=false) => {
  return (
    <>
      <h2 style={{
        marginTop: 0,
        padding: first ? 0 : "1rem 0 0 0", 
      }}>
        {title}
      </h2>
      {intro}
      <StyledDataList>
        {rows.map(([label, value]) => renderDataListItem(label, value))}
      </StyledDataList>
    </>
  )
}

const renderDataListItem = (label, value) => {
  return (
    <div key={label}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  )
}

const formatTimeSlot = (timeSlot) => {
  const [from, to] = timeSlot.split('-')
  return `${from}:00 - ${to}:00`
}

const VisitorAndSpendGridCellPopup = ({ data }) => {
  const props = data.properties

  return (
    <BasePopup
      coords={data.coords}
      offset={1}
      anchor="bottom"
      maxWidth="420px"
      style={{
        color: "black",
        fontSize: "13px",
        width: "auto",
        height: "440px",
        overflowY: "hidden",
      }}>

      <div style={{
        paddingLeft: "1rem",
        paddingRight: "1rem",
        marginTop: "0.5rem",
        width: "100%",
        maxHeight: "calc(440px - 2rem)", // Account for popup box margins
        overflowY: "auto",
      }}>
        {props.hex_id && renderDataList(
          "Visitor (BT Footfall)",
          (<p>Average visitors, workers and residents.</p>),
          [
            ["Hex ID", props.hex_id],
            ["Weekday", props.day],
            ["Time slot", formatTimeSlot(props.time_slot)],
            ["Visitors", props.visitor],
            ["Workers", props.worker],
            ["Residents", props.resident],
          ],
          true
        )}

        {props.ldn_ref && renderDataList(
          "Spend (MasterCard Spend)",
          spendIndexIntro(props),
          [
            ["Grid ID", props.ldn_ref],
            ["Weekday", props.day],
            ["Time slot", formatTimeSlot(props.time_slot)],
            ["Index value", props.txn_amt],
          ],
          true
        )}
      </div>
    </BasePopup>
  )
}

export default VisitorAndSpendGridCellPopup;